const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',

  LABEL_LIST:'LABEL_LIST',
  LABEL_LIST_RESULT:'LABEL_LIST_RESULT',
  LABEL_FETCH_ID:'LABEL_FETCH_ID',
  LABEL_FETCH_LIST_ID:'LABEL_FETCH_LIST_ID',




  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  LabelRead:(info)=>({
      type: actions.LABEL_LIST,
      payload:{info,page:1}
  }),
  onPageChange: (info, page) => ({
    type: actions.LABEL_LIST,
    payload: { info, page }
  }),
  labelListSuccess: (exportresult,result,success,total_count,grpfilter,page) => ({
   type: actions.LABEL_LIST_RESULT,
   exportresult,
   result,
   success,
   total_count,
   grpfilter,
   page
 }),
 labelfetchBYId:(listid)=>({
   type: actions.LABEL_FETCH_ID,
   payload:{listid}
 }),
 labelListById: (result,success) => ({
  type: actions.LABEL_FETCH_LIST_ID,
  result,
  success
}),
};
export default actions;
